// @ts-strict-ignore
import type { FilteredDashboardApiEndpointKeys, dashboardApiEndpoints } from "@dashboardApi/apis";

import { postMessageFetcher } from "@lib/postMessageFetcher";

import { useBrazeDashboardConfig } from "@services/brazeDashboardConfig";

/**
 * This hook returns a function that can be used as a fetcher function for react-query.
 * The fetcher function utilizes the PostMessage and MessageChannel API to communicate with the parent window.
 * This is used in the editor domain to communicate with the parent window.
 * The editor domain is not allowed to communicate with the backend directly to prevent XSS attacks.
 * @param endpoint a key into the global API endpoint definitions.
 */
export const useEditorDomainApiQueryFetcher = <
  Endpoint extends FilteredDashboardApiEndpointKeys<typeof dashboardApiEndpoints, "GET">,
  Arguments extends any[],
>(
  endpoint: Endpoint
) => {
  const dashboardUrl = useBrazeDashboardConfig("dashboardUrl");

  return (_, ...args: Arguments) => {
    return postMessageFetcher({
      endpoint,
      method: "GET",
      args,
      targetOrigin: dashboardUrl,
    });
  };
};
